module.exports = __webpack_public_path__ + "img/cards.4f2d61da.png";